import { useAuthClient, useUserLogin } from '@gef-ui/authorization-v2';
import { useConfig } from '@gef-ui/env-config';
import { getAccessToken, getSafeUserLogon } from '@gef-ui/redux-common/selectors/appContext';
import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getApmConfig } from '../selectors';
const useApmConfig = ()=>{
    const apmEnvConfig = useConfig()?.apm;
    const reduxConfig = useSelector(getApmConfig);
    return apmEnvConfig || reduxConfig;
};
const useApmUserLogin = (userLoginSelector = getSafeUserLogon)=>{
    const userLogin = useSelector(userLoginSelector);
    const authLogin = useUserLogin();
    return authLogin || userLogin;
};
// todo tohle by melo jit lepe pres useStore
const useGetAccessToken = ()=>{
    const authAccessToken = useAuthClient()?.getAccessTokenFromCache;
    const accessToken = useSelector(getAccessToken);
    const lazyToken = useRef(accessToken);
    useEffect(()=>{
        lazyToken.current = accessToken;
    }, [
        accessToken
    ]);
    const getLazyAccessToken = useMemo(()=>()=>lazyToken.current, []);
    return authAccessToken || getLazyAccessToken;
};
export default {
    Apm: {
        useConfig: useApmConfig,
        useUserLogin: useApmUserLogin,
        useGetAccessToken
    }
};
